module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1046.5c6e15da.png";